/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./LatestAbsenceInfo.vue?vue&type=template&id=f0fdbe60&scoped=true&"
import script from "./LatestAbsenceInfo.vue?vue&type=script&setup=true&lang=js&"
export * from "./LatestAbsenceInfo.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./LatestAbsenceInfo.vue?vue&type=style&index=0&id=f0fdbe60&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0fdbe60",
  null
  
)

export default component.exports